import HTTPClient from './http-client';

const END_POINT = '/basin';
const options = {
    cache: {
        maxAge: 24 * 60 * 60 * 1000,
        exclude: { query: false }
    }
};

const loadBasins = async (customer_id) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
        `${END_POINT}?customer_ids=${customer_id}`,
        options
    )
};

export {
    loadBasins
}